import React from 'react'
import { useKeyPressEvent, useBoolean } from 'react-use'

import { useQuizContext } from 'store/QuizStore'

import { Root, LogoBox, ReadyBox } from './AppHeader.styled.js'

import { ReactComponent as LogoIcon } from './../../assets/logo.svg'
import { ReactComponent as ReadyIcon } from './../../assets/ready-icon.svg'

const iconColors = {
  intro: 'white',
  quiz: 'primary',
  message: 'white',
  results: 'primary',
}

const AppHeader = () => {
  const { reset, showWelcome, currentScreen } = useQuizContext()
  const [shift, toggleShift] = useBoolean(false)

  useKeyPressEvent('b', toggleShift, toggleShift)

  const handleClick = () => {
    if (shift) {
      reset()
    }
  }
  return (
    <Root p={[16, 40, 40, 80]} topLayer={currentScreen === 'intro' || !showWelcome}>
      <LogoBox clr={iconColors[currentScreen]} onClick={handleClick} w={[120, 160, 160, 184]}>
        <LogoIcon></LogoIcon>
      </LogoBox>
      <ReadyBox clr={iconColors[currentScreen]} w={[100, 120, 120, 131]}>
        <ReadyIcon></ReadyIcon>
      </ReadyBox>
    </Root>
  )
}

export default AppHeader
